// extracted by mini-css-extract-plugin
export default {"pageContent":"App_pageContent__OVA1A","skjema":"App_skjema__0EKw3","inputMedium":"App_inputMedium__DHLzj","inputSmall":"App_inputSmall__PElPY"};